import React, { useEffect } from 'react';
import parse from 'html-react-parser'; 
import ImageSlider from './ImageSlider';

const openCalendlyInParent = (url) => {
  window.parent.postMessage({
      action: 'openCalendly',
      url: url
  }, '*');
};

const ListingInfo = ({ listing, filterSpaceType }) => {
  const {
    Name: name = 'Unknown',
    SpaceAvailableSqft: sqft = 'Unknown',
    SpaceDescription: description = 'No description available',
    LeasePrice: { MinPrice: minPrice } = { MinPrice: 'Not available' },
    Photos: photos = [],
    UserDefinedFields: userDefinedFields = []
  } = listing;

  const safeDescription = description || 'No description available';
  const spaceTypeObj = userDefinedFields && userDefinedFields.length ? userDefinedFields.find(field => field.Key === "Space Type") : null;
  const spaceType = spaceTypeObj ? spaceTypeObj.Value : 'Not defined';

  if (filterSpaceType && filterSpaceType !== spaceType) {
    return null;
  }
  
  function truncateDescription(description, length) {
    if (description.length <= length) {
        return description;
    }

    const uptoLength = description.slice(0, length);
    const lastSpaceIndex = uptoLength.lastIndexOf(' ');

    // If there's no space or the last space is very near to the end, just use the original `uptoLength`
    const truncated = (lastSpaceIndex === -1 || lastSpaceIndex > length - 4)
        ? uptoLength
        : description.slice(0, lastSpaceIndex);

    return `${truncated}...`;
  }

  const truncatedDescription = truncateDescription(safeDescription, 120);
  const parsedTruncatedDescription = parse(truncatedDescription);

  const formattedPrice = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(minPrice);

 
  return (
    <div className="space-wrap">
      <div className="space-list-left">
        <ImageSlider images={photos} />
      </div>

      <div className="space-list-right">
        <div className="moreStuff">
          <a href={`https://artthausstudios.com/studio/${encodeURIComponent(name)}`} target="_blank" rel="noopener noreferrer">View details</a>
        </div>
        
        <div className="spaceStuff">
          <div className="spaceTitle">
            <h3>{name}</h3>
          </div>
          <div className="feet-list">
            <div className="feet">{sqft} sq. ft.</div>
            <span className="green-line">|</span>
            <div className="rent">${formattedPrice}/month</div>
          </div>
          <div className="suitability-text">{(parsedTruncatedDescription)}</div>
          <div className="icon-box">
            <img src="https://artthausstudios.com/wp-content/uploads/amenities-icon.svg" alt="Amenities Icon" />
          </div>
        </div>

        <div className="buttonContainer">
          <span className="moreBtn">
            <a href="#" onClick={() => openCalendlyInParent('https://calendly.com/artthaus-leasing/leasing-call')}>INQUIRE</a>
          </span>
          <span className="moreBtn">
            <a href="#" onClick={() => openCalendlyInParent('https://calendly.com/artthaus-leasing/leasing-tour')}>TOUR</a>
          </span>
          <span className="moreBtn">
            <a href="https://artthausstudios.com/lease-now/" target="_blank" rel="noopener noreferrer">APPLY</a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListingInfo;